import { useState } from "react";

import Banner from "../../components/banners/clubmed";
import CardRegistration from "../../components/cardRegistration";
import DescriptionEventClubmed from "../../components/descriptionEvent/clubmed";
import EventBannerClubMed from "../../components/eventBanner/clubmed";
import Footer from "../../components/footer";
import Header from "../../components/header";
import ScrollingBackground from "../../components/line";
import TableClubmed from "../../components/tables/clubmed";
import ButtonTwo from "../../components/buttonTwo";
import FormData from "../../components/form";

import {
  ContainerCards,
  ContainerRegisteredButton,
  ContainerRegistrations,
  ContentRegistrations,
  ContentTitle,
  DescriptionRegistrations,
  IconRegistrations,
} from "../comandatuba/styles";

import RegistrationsIcon from "../../assets/icons/icons_registrations.svg";

const ClubMed = () => {
  const handleClose = () => setOpenModal(false);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <FormData
        openModal={openModal}
        handleClose={handleClose}
        clubmed={true}
      />
      <Header />
      <Banner />
      <ScrollingBackground />
      <EventBannerClubMed />
      <ContainerRegistrations id="registration">
        <ContentRegistrations>
          <ContentTitle>
            <IconRegistrations src={RegistrationsIcon} alt="icone inscricao" />
            <span>INSCRIÇÕES DO CAIOBA</span>
          </ContentTitle>

          <ContainerCards>
            <CardRegistration
              amount="1 INSCRIÇÃO"
              amountRegistration={1}
              clubmed={true}
            />
            <CardRegistration
              amount="2 INSCRIÇÕES"
              amountRegistration={2}
              clubmed={true}
            />
            <CardRegistration
              amount="3 INSCRIÇÕES"
              amountRegistration={3}
              clubmed={true}
            />
          </ContainerCards>

          <DescriptionRegistrations>
            <span>*</span>O desconto para segunda e terceira inscrições é válido
            <span> somente para irmãos</span>. <br /> <span>**</span>Descontos
            não cumulativos.
          </DescriptionRegistrations>

          <ContainerRegisteredButton>
            <div>
              <ButtonTwo
                icon={true}
                width="100%"
                className="buttonTwo"
                onClick={() => setOpenModal(true)}
              >
                INSCREVA-SE AGORA
              </ButtonTwo>
            </div>
          </ContainerRegisteredButton>
        </ContentRegistrations>
      </ContainerRegistrations>
      <DescriptionEventClubmed />
      <TableClubmed />
      <Footer />
    </>
  );
};

export default ClubMed;
